module.exports = __webpack_public_path__ + "media/mypage/images/top/logion_top_main_visual_sp-ee5b3def52cfd0ca24059ef89af7f737.png";